import { ChevronLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { useNavigate } from '@tanstack/react-router'

import { cn } from '@/_lib/utils'
import { Title } from './typography'
import type { TabNavProps } from './tab-nav'
import { TabNav } from './tab-nav'

interface PageHeaderProps {
  title: string
  subtitle?: ReactNode
  backHref?: string
  tabs?: TabNavProps['items']
  className?: string
}

export function PageHeader({ title, subtitle, backHref, tabs, className }: PageHeaderProps) {
  const navigate = useNavigate()

  return (
    <div className={cn('flex w-full flex-col gap-4', className)}>
      <div className="flex flex-col gap-2">
        {backHref && (
          <a
            href={backHref}
            onClick={(e) => {
              e.preventDefault()
              navigate({ to: backHref })
            }}
            className="flex w-fit items-center gap-0.5 text-xs text-muted-foreground transition-colors hover:text-foreground"
          >
            <ChevronLeft size={14} />
            Voltar
          </a>
        )}
        <Title>{title}</Title>
        {subtitle}
      </div>
      {tabs && <TabNav items={tabs} />}
    </div>
  )
}
